import { Typography } from '@mui/material'
import { HelperWrapper } from 'src/components/helper-wrapper'

import { useStyles } from './styles'

const ModalTitle = () => {
  const classes = useStyles()
  return (
    <Typography className={classes.modalTitle}>
      <HelperWrapper t="impacts-library-modal-title" />
    </Typography>
  )
}

export { ModalTitle }
